import React, { useState, useEffect } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Checkbox,
  Button,
  Tooltip,
} from '@mui/material';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import PropTypes from 'prop-types';

import { RCMonitorGridAndDetails } from './RCMonitorGridAndDetails.jsx';
import { getUserFullName } from './RiskCrisis';

const InnerAccordion = ({
  crisisId,
  crisis,
  idx,
  expanded,
  checkedState,
  graphToken,
  handleExpandChange,
  handleOnChange,
  handleCreateTask,
  handleCreateGroup,
  handleTaskPlanner,
  setHasLoaded,
  getCrisisList,
  setCheckedState,
  setCrisisList,
  setFilteredCrisisList,
  memberGroupsList,
  props,
}) => {
  const [fullName, setFullName] = useState('');

  useEffect(() => {
    const getOwnerFullName = async (email) => {
      const fullName = await getUserFullName(email, graphToken);
      setFullName(fullName);
    };
    getOwnerFullName(crisis.owner);
  }, [crisis]);

  const isMemberCheck = (crisis, groupMemberList) => {
    return groupMemberList.includes(crisis.groupID);
  };

  return (
    <Accordion
      className={'monitor-tab-accordion'}
      sx={{ boxShadow: 'none' }}
      disableGutters={true}
      expanded={expanded === 'panel' + idx}
      onChange={handleExpandChange('panel' + idx)}
      TransitionProps={{ unmountOnExit: true }}>
      <AccordionSummary
        className={'monitor-tab-accordion-summary'}
        expandIcon={<ExpandCircleDownIcon sx={{ color: '#F19100' }} />}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}>
          <Checkbox
            sx={{
              '&.Mui-checked': {
                color: '#F19100',
              },
              marginRight: '1rem',
            }}
            id={crisis.crisisID}
            checked={checkedState[idx]}
            onClick={(event) => {
              handleOnChange(event, idx);
            }}
          />
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography
              variant='body1'
              sx={{
                color: 'rgba(0,0,0,0.6)',
                fontWeight: '500',
              }}>
              {crisis.crisisName ? crisis.crisisName : 'n/a'} (ID:{' '}
              {crisis.crisisID})
            </Typography>
            <Typography
              variant='body1'
              sx={{
                color: 'rgba(0,0,0,0.6)',
                fontStyle: 'italic',
              }}>
              created by {crisis.owner && typeof fullName === 'string' && fullName.length > 0 ? fullName : crisis?.modifiedBy?.fullName || 'n/a'} on{' '}
              {crisis.crisisCreationDate
                ? new Date(crisis.crisisCreationDate).toLocaleDateString(
                  'en-US'
                )
                : 'n/a'}
            </Typography>
          </div>
        </div>

        <div style={{ marginLeft: 'auto' }}>
          {crisis.groupID === null ? null : (
            <>
              <Tooltip title={isMemberCheck(crisis, memberGroupsList) ? null : `Reach out to ${fullName}:${crisis.owner} to be added to the crisis group to access planner features.`}>
                <span>
                  <Button
                    disabled={!isMemberCheck(crisis, memberGroupsList)}
                    className='add-material-popup-button'
                    variant='contained'
                    onClick={(e) => {
                      handleTaskPlanner(e, props, crisis);
                    }}
                    sx={{
                      margin: '0 10px',
                      pointerEvents: 'auto !important',
                    }}>
                    Task planner
                  </Button>
                </span>
              </Tooltip>
              <Tooltip title={isMemberCheck(crisis, memberGroupsList) ? null : `Reach out to ${fullName}:${crisis.owner} to be added to the crisis group to access planner features.`}>
                <span>
                  <Button
                    disabled={!isMemberCheck(crisis, memberGroupsList)}
                    className='add-material-popup-button'
                    variant='outlined'
                    onClick={(e) => {
                      handleCreateTask(e, props, crisis);
                    }}
                    sx={{
                      margin: '0 10px',
                      pointerEvents: 'auto !important',
                    }}>
                    Create task
                  </Button>
                </span>
              </Tooltip>
            </>
          )}
          {!crisis.groupID ? (
            <Button
              className='add-material-popup-button'
              variant='outlined'
              onClick={(e) => {
                handleCreateGroup(e, props, crisis);
              }}
              sx={{
                margin: '0 10px',
                pointerEvents: 'auto !important',
              }}>
              Create Group / Planner
            </Button>
          ) : null}
        </div>
      </AccordionSummary>
      <AccordionDetails sx={{ height: '100%', width: '100%' }}>
        {expanded && (
          <RCMonitorGridAndDetails
            setHasLoaded={setHasLoaded}
            crisisId={crisisId}
            context={props.context}
            throwError={props.throwError}
            getCrisisList={getCrisisList}
            setCheckedState={setCheckedState}
            setCrisisList={setCrisisList}
            setFilteredCrisisList={setFilteredCrisisList}
            crisisInfo={crisis}
          />
        )}
      </AccordionDetails>
    </Accordion>
  );
};

InnerAccordion.propTypes = {
  crisisId: PropTypes.string,
  crisis: PropTypes.object,
  idx: PropTypes.number,
  expanded: PropTypes.bool,
  checkedState: PropTypes.array,
  graphToken: PropTypes.string,
  handleExpandChange: PropTypes.func,
  handleOnChange: PropTypes.func,
  handleCreateTask: PropTypes.func,
  handleCreateGroup: PropTypes.func,
  handleTaskPlanner: PropTypes.func,
  setHasLoaded: PropTypes.func,
  getCrisisList: PropTypes.func,
  setCheckedState: PropTypes.func,
  setCrisisList: PropTypes.func,
  setFilteredCrisisList: PropTypes.func,
  props: PropTypes.object,
};

export default InnerAccordion;